import {
  useMemo } from "react";
  import { useTranslation } from "react-i18next";
  import {
  ProjectOutlined,
  ImportOutlined,
  InboxOutlined,
  ScanOutlined,
  ExportOutlined,
  AppstoreOutlined,
} from "@ant-design/icons";
import "../style.css";

const iconByIndex: Record<number, JSX.Element> = {
  0: <ImportOutlined />,
  1: <InboxOutlined />,
  2: <ScanOutlined />,
  3: <ExportOutlined />,
};

const HighlightsSection = () => {
  const { t } = useTranslation("wms");

  const items = useMemo(() => {
    const raw = t("highlights.items", { returnObjects: true }) as unknown;
    if (!Array.isArray(raw)) return [];
    return raw as Array<{ title: string; desc: string }>;
  }, [t]);

  const statValue = t("highlights.stat_value");
  const statLabel = t("highlights.stat_label");
  const statDesc = t("highlights.stat_desc");

  return (
    <section className="dev-wms-section dev-wms-highlights-section">
      <div className="dev-wms-section-inner">
        <h2 className="dev-section-h2 dev-wms-section-h2">
          <span className="dev-wms-section-h2-icon dev-wms-section-h2-icon--cyan" aria-hidden>
            <AppstoreOutlined />
          </span>
          <span>{t("highlights.title")}</span>
        </h2>

        <div className="dev-wms-highlights-grid">
          <div className="dev-wms-highlight-list">
            {items.map((item, idx) => (
              <div key={idx} className="dev-wms-highlight-item">
                <div className="dev-wms-highlight-icon">
                  {iconByIndex[idx] ?? <ProjectOutlined />}
                </div>
                <div>
                  <div className="dev-wms-highlight-title">{item.title}</div>
                  <div className="dev-wms-highlight-desc">{item.desc}</div>
                </div>
              </div>
            ))}
          </div>

          <div className="dev-wms-stat-card dev-wms-stat-card--ontime">
            <div className="dev-wms-stat-value">{statValue}</div>
            <div className="dev-wms-stat-label">{statLabel}</div>
            <div className="dev-wms-stat-desc">{statDesc}</div>
            <div className="dev-wms-stat-badge">{t("highlights.stat_badge")}</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HighlightsSection;
